import React from "react"
// import { css } from "@emotion/core"
import { graphql } from "gatsby"
// import { rhythm } from "../../utils/typography"
import Layout from "./layout"


import Collapse from '@material-ui/core/Collapse'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

import Img1 from "./_images/git.png"


const IndexPage = ({ data }) => {

  const [p1, showProject1] = React.useState(true)
  const [p2, showProject2] = React.useState(true)
  const [p3, showProject3] = React.useState(true)
  const [p4, showProject4] = React.useState(true)

  const [e1, showExercise1] = React.useState(true)
  const [e2, showExercise2] = React.useState(true)
  const [e3, showExercise3] = React.useState(true)
  const [e4, showExercise4] = React.useState(true)
  const [e5, showExercise5] = React.useState(true)
  const [e6, showExercise6] = React.useState(true)
  const [e7, showExercise7] = React.useState(true)
  const [e8, showExercise8] = React.useState(true)
  const [e9, showExercise9] = React.useState(true)
  const [e10, showExercise10] = React.useState(true)






  function handleClick1(id) {
    switch (id) {
      case "p1":
        showProject1(!p1)
        break;
    }
  }
  function handleClick2(id) {
    switch (id) {
      case "e1":
        showExercise1(!e1)
        break;
    }
  }
  function handleClick3(id) {
    switch (id) {
      case "e2":
        showExercise2(!e2)
        break;
    }
  }
  function handleClick4(id) {
    switch (id) {
      case "e3":
        showExercise3(!e3)
        break;
    }
  }
  function handleClick5(id) {
    switch (id) {
      case "e4":
        showExercise4(!e4)
        break;
    }
  }

  function handleClick6(id) {
    switch (id) {
      case "e5":
        showExercise5(!e5)
        break;
    }
  }

  function handleClick7(id) {
    switch (id) {
      case "p2":
        showProject2(!p2)
        break;
    }
  }

  function handleClick8(id) {
    switch (id) {
      case "e6":
        showExercise6(!e6)
        break;
    }
  }

  function handleClick9(id) {
    switch (id) {
      case "p3":
        showProject3(!p3)
        break;
    }
  }

  function handleClick10(id) {
    switch (id) {
      case "e7":
        showExercise7(!e7)
        break;
    }
  }

  function handleClick11(id) {
    switch (id) {
      case "p4":
        showProject4(!p4)
        break;
    }
  }
  function handleClick12(id) {
    switch (id) {
      case "e8":
        showExercise8(!e8)
        break;
    }
  }
  function handleClick13(id) {
    switch (id) {
      case "e9":
        showExercise9(!e9)
        break;
    }
  }
  function handleClick14(id) {
    switch (id) {
      case "e10":
        showExercise10(!e10)
        break;
    }
  }

  return (

    <Layout>
      <h1><p>Projects</p></h1>
      <div className="accordion-list">
     <ListItem id='p1' className="accordion" button onClick={() => handleClick1("p1")}>
          <ListItemText primary='Project 1' className="accordion-heading  maxw-20" /> Hyperlinked Set
        </ListItem>
        <Collapse in={!p1} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <img style={{ marginBottom: `.5rem` }} src={'https://d2w9rnfcy7mm78.cloudfront.net/662383/original_5ab90192d02c4430a9980f6a9bdf3bd7.gif?1469307808'}></img>
              <h6 style={{ marginTop: `0rem`, marginBottom: `3rem` }}>Ted Nelson, <i>hypertext links in ELF (Evolutionary List File)</i>, 1998</h6>
              <h5>Overview</h5>
              Hyperlinks are the essence of web. For a user experience, designers need to create a hyperlink structure that allows various kinds of browsing content. Based on how the contents are parsed and connected to each other via hyperlinks, a designer can create a new reading of the content. In this project, we will explore how we can use hyperlinks to catalogue items in a creative way.
              <h5>Assignment</h5>
              <p>Curate a set of content. For the content, you will select items such as books, objects, images, drawings, texts, quotes, sounds, videos, anything that interests you (minimum 3 items). You must be able to explain how these items are connected. </p>
              <p>Design and develop a hyperlink structure that serves as a catalogue of the items. You will build a website that explains the connection between the items through hyperlinks. The outcome must include a landing page, links to all items you selected, and a description about the set. The structure and organization of the content is up to you but users should be able to understand the connection of the items within the set along why they are chosen, an overview of all materials in the set, and individual destinations with details about each item in the set.</p>
              <h5>Things to consider</h5>
              <ul>
                <li>What aspect of the set do you want to present?</li>
                <li>How the catalogue of items should be broken down into units?</li>
                <li>How individual units of the set should be connected? Do you present each unit sequentially, or all instantaneously? Are you allowing the user choices?</li>
                <li>How could links be indicated? Do you have different types of links?</li>
                <li>Should the hyperlink structure be placed in a single webpage or multiple webpages?</li>
              </ul>
              <h5>Schedule</h5>
              <h6>10/13/26: Planning - Research and Sketch</h6>
              <ul>
                <li>Collect a list of items you want to catalogue and articulate your curatorial perspective and goals of the catalogue.</li>
                <li>Find 1–2 other websites that handle similar information in interesting ways and analyze why they work well.</li>
                <li>Make 2 different link structure ideas for your catalogue, each addressing how all items will link to each other. The sketch could be a form of sitemap, diagram, or wireframe. Include a 1–2 sentence description for each sketch.</li>
                <li>Aggregate all of this information into a proposal document. In the class, you will give a 5 minute presentation based on your proposal.</li>
              </ul>
              <h6>10/20/26: Design and Prototype </h6>
              <ul>
                <li>Based on your sketch, you will design a series of screen sequences showcasing the main flow of your hyperlink structure by using a prototype software (Figma, Adobe XD, etc).</li>
              </ul>
              <h6>11/03/26: Development</h6>
              <ul>
                <li>Start to develop your website using HTML/CSS/JS. Remember correct file organization and semantic markup. Carefully prioritize tasks and finish them in order: what are the most important elements/functionalities in your project?
                  In this stage, the basic link flow of your site should be basically functioning as intended. 
                </li>
              </ul>
              <h6>11/10/26: Testing, Review, and Launch</h6>
              <ul>
                <li>Refine your design and web prototype. Upload your final project to your GitHub repository, and add links to the project on your Github homepage. Post the links in Slack with the channel <span class="code">#(yourname)</span>.</li>
              </ul>
            
              <h5>References</h5>
              <h6>Sequential</h6>
              <ul>
                <li><a href="http://www.teleportacia.org/war/">Olia Lialina, My Boyfriend Came Back from the War </a></li>
                <li><a href="https://hitosteyerl.vanabbe.nl/">Studio Moniker, a digital campaign for Hito Steyerl's exhibition at Van Abbemuseum</a></li>
              </ul>
              <h6>Map</h6>
              <ul>
                <li><a href="https://animalsasobjects.org/">Trust, Son La Pham and Claire Tolan, Animals as Objects</a></li>
                <li><a href="http://torquetorque.net/">Jake Dow-Smith Studio, Torque Editions </a></li>
                <li><a href="http://predominant.ly/">Open Work, Predominant.ly</a></li>
              </ul>
              <h6>Category or tag based</h6>
              <ul>
                <li><a href="https://www.catalogtree.net/">Catalogtree, Catalogtree 5.0</a></li>
                <li><a href="https://anishkapoor.com/">Anish Kapoor website</a></li>
                <li><a href="http://exhibitions.guggenheim.org/storylines/">Guggenheim, Storylines </a></li>
              </ul>
            
                <h6><b>Resources</b><br/>
             *Password protected, find it in our class Slack</h6>
              <ul>
                <li><a href="https://www.figma.com/proto/tgnfpsc3IU3sOawNrjzUYX/Design-process-examples?node-id=1-212&p=f&t=EDHkmx1Nbdbq984w-1&scaling=scale-down-width&content-scaling=fixed&page-id=0%3A1" target="_blank">Sitemap example</a></li>
                <li><a href="https://www.figma.com/proto/tgnfpsc3IU3sOawNrjzUYX/Design-process-examples?node-id=21-382&p=f&t=38rOLfm2pGoMXtFQ-1&scaling=scale-down-width&content-scaling=fixed&page-id=17%3A47" target="_blank">Wireframe example</a></li>
                <li><a href="https://www.figma.com/proto/tgnfpsc3IU3sOawNrjzUYX/Design-process-examples?node-id=1-212&p=f&t=EDHkmx1Nbdbq984w-1&scaling=scale-down-width&content-scaling=fixed&page-id=0%3A1" target="_blank">Storyboard example</a></li>
              </ul>
            </div>
          </List>
        </Collapse> 



        {/* <ListItem id='p2' className="accordion" button onClick={() => handleClick11("p4")}>
          <ListItemText primary='Project 2' className="accordion-heading  maxw-20" /> Change Over Time
        </ListItem>
        <Collapse in={!p4} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <img style={{ marginBottom: `.5rem`, maxWidth: `200px` }} src={Img1}></img>
              <h6 style={{ marginTop: `0rem`, marginBottom: `3rem` }}>
                Diagram for GIT, from <i><a href="https://www.dropbox.com/scl/fi/wx7c9odlxgeopttk666zj/david_reinfurt_infinite_versioning.pdf?rlkey=eb18wp6paadcxknoy125qkji5&dl=0" target="_blank">Infinite Versioning</a></i>, David Reinfurt, 2014
              </h6>
              <p style={{ lineHeight: '1', paddingLeft: '2.7rem' }}>
                <span class="small">
                  Many of our sites are designed to change. They don’t change on their own; rather, they are dependent on limitless streams of dynamic external input, and their design is built around ideas about the nature of those streams.
                  — Dan Michaelson (Linked by Air), <i><a href="https://www.dropbox.com/s/vrbohg2yuvc8ex0/Linked%20by%20Air-%20Change.pdf?dl=0" target="_blank" rel="noopener noreferrer">Change Over Time</a></i>
                </span>
              </p>
              <p style={{ lineHeight: '1', paddingLeft: '2.7rem' }}>
                <span class="small">
                  We’re working on our new website. Instead of promising a grand relaunch, we decided to keep the work in plain view. During the next few months, you’ll be able to see the changes taking place here: different themes, typographic styles and image treatments will be tried occasionally. It may happen very quickly. It may take a long time, and we might end up with something almost unchanged after all. In any case, you will see when it’s done that it’s done
                  — Sulki & Min, 2013 </span>
              </p>



              <h5>Overview</h5>


              A website is a medium that is intended to present changing content and form. Web technology allows users to easily switch the content and provides interactions that create visual changes over time. Considering a life of a website after it is launched, designers need to consider this technological condition for their design. In this assignment, we will be taking this challenge as a creative context and explore how to embrace and expand changes as a part of your design.
              <h5>Assignment</h5>
              Choose an event. The event could be already existing or fictional, but has to be a time-based happening(s): an exhibition, a music festival, etc. Create a single-page website that informs the viewer about the event reflecting its progress. Think about what events’ changing points are over time, and how the website could have visual connections with these changes. The website must present <i>at least two different states</i> following the event’s timeline. The series of these changes should be applied through the entire website as a cohesive visual direction, more than a few elements on the website. The outcome must include the basic information about the event (the title, the time, a description).
              <h5>Things to consider</h5>
              <ul>
                <li>What is the purpose for the website in relation to the actual event: advertisement, archive, or an event itself (a live performative space), etc.</li>
                <li>Triggers to initiate the change: time, location, weather, user interactions, etc.</li>
                <li>Variables between the changes: how the website could be understood as a consistent / comprehensive visual container of the event but also create enough differences along the context of its change</li>
                <li>Possible timeframes of change: 1 second, 1 minute, 1 hour, 1 day, 1 month, or some other schedule</li>
              </ul>
              <h5>Schedule</h5>
              <ul>
                <h6>11/11/26: Planning and Design Sketch</h6>
                <li>
                  Develop a storyboard of at least two screens that illustrate key changing points of your event over time.
                  Based on your storyboard, create an initial visual design with at least one screen that includes visual layout and major content elements.
                  Make sure to use design software like Figma or Adobe XD for both the storyboard and visual design to ensure proper scaling and spacing (No hand-drawings!)
                </li>
                <h6>11/18/26: Design and Prototype Research</h6>
                <li>Develop and refine your screen designs further. Start to research relevant web programming languages and test them out in browser. </li>
                <h6>11/25/26: Prototype</h6>
                <li>Prototype your design in browser. In this stage, each stage of 'change' on your prototype should be presented as intended. Carefully prioritize programing tasks and finish them in order. </li>
                <h6>12/02/26: Test and launch</h6>
                <li>Test your prototype to identify and address any issues or bugs. Refine the design or functionality as needed. Once the site is ready, upload your final project to your Github repository, and add links to the project on your Github homepage. Post the links in Slack with the channel <span class="code">#(yourname)</span>. </li>
              </ul>

              <h5>References</h5>

              <ul>
                <li><a href="https://drive.google.com/file/d/1UiTaKIQQ1cW3IU11awTW4jAUm2s4F8pT/view?usp=drive_link" target="_blank">Slides</a>
                </li>
              </ul>
              <h6>Clock</h6>
              <ul>
                <li><a href="http://hummingbirdclock.info/" target="_blank" rel="noopener noreferrer">The Hummingbird Clock</a></li>
                <li><a href="http://work.damonzucconi.com/floating-point-year/" target="_blank" rel="noopener noreferrer">Floating Point Year</a></li>
                <li><a href="http://o-r-g.com/apps/wyoscan" target="_blank" rel="noopener noreferrer">Wyoscan</a></li>
              </ul>
              <h6>Tracing changes</h6>
              <ul>
                <li><a href="https://www.hoverstat.es/features/second-thoughts" target="_blank" rel="noopener noreferrer">Second Thoughts</a></li>
                <li><a href="https://averyreview.com/issues/1/partial-recall" target="_blank" rel="noopener noreferrer">Hottest To Coldest</a></li>
              </ul>
              <h6>Open/close</h6>
              <ul>
                <li><a href="https://radioamnion.net/" target="_blank" rel="noopener noreferrer">Radio Amnion</a></li>
              </ul>
              <h6>Streaming</h6>
              <ul>
                <li><a href="https://www.youtube.com/watch?v=qTg6Gl3gD8M&ab_channel=sagmeisterinc" target="_blank">Stefan Sagmeister's old website</a></li>
                <li><a href="http://allatonce.space/" target="_blank" rel="noopener noreferrer">All at Once</a></li>
              </ul>
            </div>
          </List>
        </Collapse>  */}
        
      </div>
      <h1 style={{ marginTop: `5rem` }}><p>Exercises</p></h1>
      <div className="accordion-list" style={{ marginTop: `0rem`, marginBottom: `5rem` }}>
        <ListItem id='e1' className="accordion" button onClick={() => handleClick2("e1")}>
          <ListItemText primary='Exercise 1' className="accordion-heading  maxw-20" /> Hello World
        </ListItem>
        <Collapse in={!e1} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 09/22/26</h6>
              <p> Follow the steps in <a href="https://docs.google.com/document/d/1vk6vJiTXhBOPzLV6Qt5Xkc3Q-IgyIl4uN5zsw0bEttY/edit?usp=sharing"><i>GitHub: Getting Started</i></a> to set up your class repository and publish your first HTML page, “Hello World.” </p>             <ul> 
              <li>Create a new file named <span class="code">index.html</span> in Sublime Text.</li> <li>Add a basic HTML structure using <a href="https://developer.mozilla.org/en-US/docs/Learn/Getting_started_with_the_web/HTML_basics#anatomy_of_an_html_document">this MDN example</a>.</li> <li>Add “Hello World” to the page and save the file inside your local GitHub repository folder.</li> <li>Commit and push <span class="code">index.html</span> to GitHub. This will serve as the landing page for your site.</li> <li>Post the link to your published GitHub site in your Slack channel, <span class="code">#(yourname)</span>.</li> </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='e2' className="accordion" button onClick={() => handleClick3("e2")}>
          <ListItemText primary='Exercise 2' className="accordion-heading  maxw-20" /> Handmade Web — HTML
        </ListItem>
        <Collapse in={!e2} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 09/22/26</h6>

              <p>Semantically mark up an essay on J. R. Carpenter's <i>Handmade Web</i>. You will create a set of html pages (two or more) that are connected by hyperlinks. </p>
              <ul>
                <li>To begin, download text <a href="https://drive.google.com/file/d/1s2HmTbiFH5bhvYP9v3BMO0DTgWeeZZ1R/view?usp=sharing" target="_blank">here</a> and divide the text into multiple sections to create hyperlink sequences.</li>
                <li>Download HTML template <a href="https://drive.google.com/file/d/1FpWgegiLkPblTFwCR2E423cx_CeBfGBp/view?usp=sharing" target="_blank">here</a> and save at the appropriate location in your local computer. Duplicate them to match the number of your text sections.</li>
                <li>Open each HTML template file in your text editor and copy and paste the relevant sections from the essay into the template. </li>
                <li>Mark-up the document by keeping in mind which HTML tags are appropriate for which segments of content. 
                  During this step, carefully proofread for correct glyphs (such as quotation marks, dashes, and other Unicode characters) and ensure proper formatting. You may also consider reformatting these elements typographically to suit your design—for example, by indenting or italicizing a quote block instead of using quotation marks.</li>
                <li>Add a hyperlink on each page to connect one another.</li>
                <li>Test your results by opening the local HTML file in your chosen web browser.</li>
                <li>Upload your HTML file to your GitHub repository, and test your results again with the repository URL</li>
                <li>Post the link in Slack with the channel <span class="code">#(yourname)</span>.</li>
              </ul>
              <h5>References</h5>
              <h6>Multi-page Storytelling Examples</h6>
              <ul>
                <li>Olia Lialina, <a href="http://www.teleportacia.org/war/" target="_blank"> My Boyfriend Came Back from the War</a></li>
                <li>Closky, <a href="https://awp.diaart.org/closky/" target="_blank">Do You Want Love or Lust?</a></li>
                <li>Penelope Umbrico, <a href="https://www.ubu.com/contemp/umbrico/AllCatalogs/index.html" target="_blank">All Catalogues</a></li>
              </ul>
              <h6>Web Typography</h6>
              <ul>
                <li><a href="https://practicaltypography.com/" target="_blank">Butterick's Practical Typography</a></li>
                <li><a href="https://www.typewolf.com/cheatsheet" target="_blank">TypeWolf: Typography Cheatsheet</a></li>
                <li><a href="https://www.unicode.org/charts/nameslist/n_2000.html"  target="_blank">Unicode General Punctuation</a></li>
              </ul>
            </div>
          </List>
        </Collapse>
        <ListItem id='e3' className="accordion" button onClick={() => handleClick4("e3")}>
          <ListItemText primary='Exercise 3' className="accordion-heading  maxw-20" /> Handmade Web — CSS
        </ListItem>
        <Collapse in={!e3} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 09/29/26</h6>
              <p>Using your new knowledge of some simple CSS styling properties, style the Handmade Web content that you already marked up in a previous exercise. <i>Create an external CSS file</i> to style your content, experimenting with color, scale, and positioning to further familiarize yourself with this new language.</p>
              <h6>Step 1</h6>
              <p>During the class, focus on the basic CSS setup and testing micro styles (fonts, color, inline typography styles, etc). Keep in mind webfont implementation and font properties.</p>
              <h6>Step 2</h6>
              <p>After the class, continue styling the document per the <a href="https://docs.google.com/presentation/d/1Pl1JX77fW7wF4B3SSmCgjSqU-gEiKkmykdi7s2GX5zc/edit?usp=sharing" target="_blank" rel="noopener noreferrer">CSS Layout</a> checklist below:</p>
              <ul>
                <li>Review markup: Ensure proper use of inline and block-level elements in your HTML.</li>
                <li>Position: Set positioning with  <span class="code">display</span>,  <span class="code">float</span>, and  <span class="code">position</span> properties. Setting borders and toggling the border style on the process could be helpful to understand the structure.</li>
                <li>Spacing: Customize spacing using padding and margin.</li>
                <li>Box properties: Modify box properties like  <span class="code">width</span>,  <span class="code">height</span>,  <span class="code">border</span>, etc.</li>
                <li>Wrap & alignment: Consider using CSS Flexbox or Grid to align multiple items.</li>
              </ul>
              <p>Update your html file to your GitHub repository, and add a link to the page on the GitHub homepage. Post the link in Slack with the channel <span class="code">#(yourname)</span>.</p>
            </div>
          </List>
        </Collapse>  
       
       <ListItem id='e5' className="accordion" button onClick={() => handleClick6("e5")}>
          <ListItemText primary='Exercise 4' className="accordion-heading  maxw-20" /> CSS Letterforms — Composition
        </ListItem>
        <Collapse in={!e5} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 10/06/26</h6>
              <p>Choose a letter from the alphabet (excluding I, L, and T), and design more than 5 distinct variations of that letter using only HTML and CSS. </p>
              <h6>Workflow & Guidelines</h6>
                <ul>
                  <li>Build the Structure: Break the letter into basic strokes or shapes. Group related elements inside a wrapper to keep your HTML organized and clear.</li>
                  <li>Position & Align: Decide whether to move individual strokes or entire groups. Practice positioning and alignment to understand the relationship between local positioning (within a group) and global positioning (on the page).</li>
                  <li>Shape & Style: Use CSS to create shapes like rectangles, circles, or triangles. Experiment with color, transparency, and shadows to explore positive and negative space. Reuse class names for repeated elements such as strokes or arms.</li>
                </ul>
               <h6>Past Example</h6>
              <ul>
                <li><a href="http://b.parsons.edu/~sabbm950/ex8letter.html" target="_blank">P by Marine Sabbagh</a></li>
              </ul>
              <h6>Other Examples</h6>
              <ul>
                <li>Rafaël Rozendaal: <a href="https://www.moma.org/calendar/exhibitions/5774" target="_blank">Light</a>, and <a href="https://www.newrafael.com/internet/">more</a></li>
              </ul>
            </div>
          </List>
        </Collapse> 
         <ListItem id='e6' className="accordion" button onClick={() => handleClick8("e6")}>
          <ListItemText primary='Exercise 5' className="accordion-heading  maxw-20" /> CSS Letterforms — Motion
        </ListItem>
        <Collapse in={!e6} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <h6 style={{ marginTop: `0rem` }}>Due 10/06/26</h6>
              <p>
                Choose one of your letterforms from the previous exercise and create a new HTML page with the chosen letterform. You will apply your new knowledge of CSS motion properties to enhance and enliven the composition.
                Use at least 1 CSS transition or 1 CSS animation when the user hovers over some component of the letterforms.</p>
              <p>
                Think about interactivity—given the content and structure of the letterforms, what can happen on hover?
                You may want to reconsider alignment of each strokes, or other graphic elements such as letter space and background color, that can be incorporated to illustrate motion.
              </p>
              <p>
                Upload your html files to your GitHub repository, and add links to the pages on the GitHub homepage. Post the links in Slack with the channel <span class="code">#(yourname)</span>.
              </p>
              <h6>Past Examples</h6>
              <ul>
                <li><a href="https://dinginginging.github.io/ding/ex4/type.html" target="_blank">Q by Steven Ding</a></li>
                <li><a href="https://femathjr.github.io/Exercise_5-6_CSS_Letterforms/4_letter_styles/4letterVersionsV2.html" target="_blank">F by Fred E. Mathelier Jr.</a></li>
              </ul>
              <h6>Demos</h6>
              <ul>
                <li><a href="https://codepen.io/mkimkimkimk/pen/oNwOeMN" target="_blank">Style child element when hover on parent</a></li>
                <li><a href="https://codepen.io/mkimkimkimk/pen/rNvdZEp" target="_blank">Style an element when hover on a sibling element</a> by using <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/Next-sibling_combinator" target="_blank"> CSS next-sibling combinator</a></li>
                <li><a href="https://codepen.io/mkimkimkimk/pen/xxjWyZy" target="_blank">Or when there are other items in between</a> by using <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/Subsequent-sibling_combinator" target="_blank">CSS sequential sibling combinator</a></li>
              </ul>
            </div>
          </List>
        </Collapse> 
        
        <ListItem id='e10' className="accordion" button onClick={() => handleClick14("e10")}>
          <ListItemText primary='Exercise 6' className="accordion-heading  maxw-20" /> On/Off
        </ListItem>
        <Collapse in={!e10} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <div className="img-bleed">
                <img style={{ maxWidth: '54%', paddingBottom: '10px' }} src={'https://miro.medium.com/v2/1*Vnt7qtcvOKWA8Fgmb3I2tg.gif'}></img>
                <img style={{ maxWidth: '42%', paddingBottom: '10px'}} src={'https://ulegroup.com/cdn/shop/files/4d477efa306e54dd832ba5df6c52179727644679-large.png?crop=center&height=940&v=1755250190&width=940'}></img>
                <img style={{ maxWidth: '42%', paddingRight: '3%', float: 'clear'}} src={'https://www.ibm.com/adobe/dynamicmedia/deliver/dm-aid--03dfe48f-4aff-46f6-83e4-1318faea3119/4275461a-e3fe-430c-b9afcf7e036e5da1.jpg?preferwebp=true'}></img>
                <img style={{ maxWidth: '55%', padding: '30px', paddingTop: '20px'}} src={'https://cs50.yale.edu/2019/fall/psets/4/filter/more/bitmap.png'}></img>
                <h6 style={{  marginBottom: `3rem` }}>
                  (Top Left) A digital toggle in a user interface. Image by <a href="https://dribbble.com/Volorf" target="_blank">Oleg Frolov</a><br/>
                  (Top Right) A physical light switch<br/>
                  (Bottom Left) Early computation using punch cards, which rely on binary on/off patterns. Image from <a href="https://www.ibm.com/history/punched-card" target="_blank">IBM</a><br/>
                  (Bottom Right) A binary image, with each pixel stored as a single bit: 0 or 1. Image from <a href="https://www.bbc.co.uk/bitesize/guides/zscvxfr/revision/5" target="_blank">BBC Bitesize</a>
                </h6>
              </div>
              <h6 style={{ marginTop: `0rem` }}>Due 10/13/26</h6>
              <p>A toggle is a <i>binary</i> control: each click flips a state — 0/1, on/off, show/hide, light/dark. </p>
              <p>Using the in-class demo as a starting point, create a new HTML page that uses a JavaScript toggle to produce a surprising effect. Your audience should be able to tell where to click without additional instructions, so make the control clear and inviting. Think creatively about how to play with typical user expectations, aiming for an effect that feels both unexpected and intuitive.</p>
              <ul>
                <li>Create a new HTML page and add an HTML element that will serve as a toggle.</li>
                <li>Create a new .js file and add a link to it to your HTML file</li>
                <li>Add other HTML elements whose styles you want to change when the toggle is activated. Use clear CSS selectors and organize your HTML structure for clarity and efficiency.</li>
                <li>When you’re finished, upload your work to your GitHub repository. Open the repository URL in your browser to test and confirm everything works as expected. Finally, share the link in Slack under the channel <span class="code">#(yourname)</span>.</li>
              </ul>
              <h5>References</h5>
              <ul>
                <li>Ramyatara Mullapudi, <a href="https://rmullapudi9.github.io/Project-4/" target="_blank">Playground</a></li>
                <li>Tiger Dingsun, <a href="https://tdingsun.github.io/tiger/" target="_blank">Ballast</a></li>
              </ul>
              <h5>Resources</h5>
              <ul>
                <li><a href="https://github.com/mkimk/risd-demos" target="_blank">Class demo</a></li>
                <li><a href="https://developer.mozilla.org/en-US/docs/Web/API/DOMTokenList/toggle" target="_blank">Javascript: <span class="code">toggle()</span> method</a></li>
                <li><a href="https://css-tricks.com/a-complete-guide-to-dark-mode-on-the-web/" target="_blank">A Complete Guide to Dark Mode on the Web</a></li>
              </ul>
            </div>
          </List>
        </Collapse>  
        <ListItem id='e8' className="accordion" button onClick={() => handleClick12("e8")}>
          <ListItemText primary='Exercise 7' className="accordion-heading  maxw-20" /> Debugging with AI—Ask, Test, Verify
        </ListItem>
        <Collapse in={!e8} timeout="auto"  unmountOnExit>
          <List component="div" disablePadding>
          <div className="accordion-content">
            <p>Use an AI tool to help you work with the <a href="https://github.com/mkimk/risd-demos" target="_blank">provided JavaScript code</a> <span class="code">(demo reposotiry > 07-troubleshooting)</span>. You will: 1) Diagnose the existing problem. 2) Test and repair it. 3) Make one additional change to the interaction.</p>
            <p>The goal is not simply to produce working code, but to understand the problem, evaluate the AI’s suggestions, and make an intentional change of your own. Do not replace the entire file with AI-generated code. Make and test one change at a time.</p>
            {/* <h6 style={{ marginTop: `0rem`}}>Demo</h6> */}
            <h5>Step 1: Observe</h5>
            <p>Open the code in the browser and check the console messages. Don't fix the code yet. Describe:</p>
            <ul>
              <li>What did you expect to happen?</li>
              <li>What actually happened?</li>
              <li>Are there any errors in the console?</li>
            </ul>
            <h5>Step 2: Ask</h5>
            <p>Share the relevant code and your observations with an AI tool. Ask it to diagnose the problem without fixing it yet:</p>
            <ul>
              <li><i>I expected <span class="code">[expected behavior]</span>, but instead <span class="code">[observed behavior]</span>. The console shows <span class="code">[error message, if any]</span>.</i></li>
              <li><em>Don’t fix or rewrite the code yet. Identify possible causes, refer to specific parts of my code and distinguish what can be verified from what is still an assumption.</em></li>
            </ul>
            <p>Review the response. Mark each claim:</p>
             <ul>
              <li>✅ I understand it and can verify it in the code or console.</li>
              <li>❓ I understand it, but need to test whether it is correct.</li>
              <li>⁉️ I don’t understand it yet. Ask the AI to explain it using concepts you have learned.</li>
              <li>➕ It introduces a change I did not request.</li>
            </ul>
            <p>Based on that, ask: </p>
            <ul>
              <li><em>I don’t understand this part of your explanation. Explain it using only the JavaScript concepts I have learned: <span class="code">[DOM queries]</span>, <span class="code">[event listeners]</span>, <span class="code">[functions]</span>, <span class="code">[variables]</span>, <span class="code">[conditionals]</span>. Do not revise the code yet.</em></li>
            </ul>
            <h5>Step 3: Test</h5>
            <p>Choose the most likely cause and ask:</p>
            <ul>
              <li><i>What is the smallest test I can run to determine whether this cause is correct? Do not rewrite the code or introduce a new structure.</i>
               <br />
                * Why the smallest change?
Changing one thing at a time helps you identify what caused the problem, understand what fixed it, and avoid unintentionally changing the rest of your project.
              </li>
            </ul>
            <p>Apply one change and test the code again.</p>
            <h5>Step 4: Repair</h5>
              <p>If the test confirms the cause, ask:</p>
              <ul>
                <li>
                 <em> The test showed <span class="code">[result]</span>. Suggest the smallest change that addresses the problem while preserving the rest of my code and intended behavior. Explain the change, then show only the lines that need to be revised.</em>
               
                  </li>
              </ul>

<p>Before applying the suggestion, identify exactly which line or lines will change. Make one change, then run the code again.</p>
       <h5>Step 5: Verify</h5>
<p>Confirm that:</p>
<ul>
          <li>The original problem is resolved.</li>

 <li>The rest of the interaction still works.</li>

 <li>The visual and interactive intention has not changed.</li>

 <li>You can explain the revised code in your own words.</li>
</ul>

<h5>Step 6: Submit</h5>

<p>Create a document that includes:</p>
<ul>
  <li>Your prompt history and the AI’s responses</li>
  <li>The test you performed and its result</li>
  <li>The changes you made to the code</li>
</ul>

<p>Upload a document and upload it to your Slack channel: <span class="code">#your-name</span>.</p>












          </div>
          </List>
        </Collapse>
     <ListItem id='e7' className="accordion" button onClick={() => handleClick10("e7")}>
          <ListItemText primary='Exercise 8' className="accordion-heading  maxw-20" /> Media Query Relay
        </ListItem>
        <Collapse in={!e7} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <div className="accordion-content">
              <img style={{ marginBottom: `.5rem` }} src={'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/14390049254313.58af348ed662e.gif'}></img>
              <h6 style={{ marginTop: `0rem`, marginBottom: `3rem` }}><i> <a href="https://essenmitsosse.de/pixel/?showcase=true&slide=2" target="_blank" rel="noopener noreferrer">Marcus Blättermann, »Responsive Pixel Art«, 2016</a></i></h6>
              <h6 style={{ marginTop: `0rem` }}>Due to 12/01/26</h6>
              <p>In this exercise, we will use our individual responses to media queries as a way to reveal our class dynamics. In the beginnings of the Surrealist movement, leading artists would play a game called <a href="https://en.wikipedia.org/wiki/Exquisite_corpse" target="_blank" rel="noopener noreferrer">Exquisite Corpse</a> because they believed that individual poetic fragments reflected an unconscious reality about the whole group. Using the same format, we will create a Exquisite Corpse with media query in a html page.</p>
              <p>In the given html, there are 15 blank media queries. Each participant is responsible for writing the CSS for one media query in order below.</p>
              <ul class="mq">
                <li class="small">E Jun: @media screen and (min-width: 640px) and (max-width: 705px) by 3pm 10/20/26</li>
                <li class="small">Jaclyn: @media screen and (min-width: 705px) and (max-width: 770px) by 4pm 10/20/26</li>
                <li class="small">Evelyn: @media screen and (min-width: 770px) and (max-width: 835px) by 5pm 10/20/26</li>

                <li class="small">Hailey: @media screen and (min-width: 835px) and (max-width: 900px) by 3pm 11/03/26</li>
                <li class="small">Juan: @media screen and (min-width: 900px) and (max-width: 965px) by 4pm 11/03/26</li>
                <li class="small">James: @media screen and (min-width: 965px) and (max-width: 1030px) by 5pm 11/03/26</li>

                <li class="small">Karis: @media screen and (min-width: 1030px) and (max-width: 1095px) by 3pm 11/17/26</li>
                <li class="small">Yolizabeth: @media screen and (min-width: 1095px) and (max-width: 1160px) by 4pm 11/17/26</li>
                <li class="small">Eva: @media screen and (min-width: 1160px) and (max-width: 1225px) by 5pm 11/17/26</li>

                <li class="small">Anushka: @media screen and (min-width: 1225px) and (max-width: 1290px) by 3pm 11/24/26</li>
                <li class="small">Sherry: @media screen and (min-width: 1290px) and (max-width: 1355px) by 4pm 11/24/26</li>
                <li class="small">Helen: @media screen and (min-width: 1355px) and (max-width: 1420px) by 5pm 11/24/26</li>

                <li class="small">Iris: @media screen and (min-width: 1420px) and (max-width: 1485px) by 3pm 12/01/26</li>
                <li class="small">Amber: @media screen and (min-width: 1485px) by 4pm 12/01/26</li>
              </ul>
              <h5>Steps</h5>
              <ul>      
                <li>Check your email inbox (associated with the GitHub account you used to create your class repository), and accept the new Github repository invitation. The subject line should read: <i>[GitHub] @mkimk has invited you to...</i></li>
                <li>Sync <a href="https://github.com/mkimk/wam1f26" target="_blank" rel="noopener noreferrer">this repository</a> to your computer: Click <i>Code</i> button on the repository, with an option <i>Open with GitHub Desktop</i>. Then clone the repository in your local folder.</li>
                <li>Find the html page in the synced folder and open it in your text editor.</li>
                <li>In the HTML file, find the following code block; this is where you should insert your code:</li>
                <div class="code_block">
                  <span class="blue">@media</span> screen <span class="blue">and</span> <span class="yellow">(</span><span class="purple">min-width:</span> ###px<span class="yellow">)</span> <span class="blue">and</span> <span class="yellow">(</span><span class="purple">max-width:</span> ###px<span class="yellow">) &#123;</span><span class="green"> / * your name  * / </span><br />
                  &#160;&#160; <span class="green"> // Your CSS code goes here </span><br />
                  <span class="yellow"> &#125;</span>
                </div>
                <li>Within the assigned time window, write CSS for your assigned media query. Considering the previous student’s media query styles and create a layout that works well at your aspect ratio. Make <i>at least 10 style changes</i> between yours and the previous query, and try to make smooth transitions between the changes. You are responsible only for the assigned media query, don’t manipulate other sections or HTML.</li>
                <li>Commit the file to GitHub, and verify that the changes are reflected on both the repository page (<a href="https://github.com/mkimk/wam1f26/" target="_blank">https://github.com/mkimk/wam1f26/</a>) and the live site (<a href="https://mkimk.github.io/wam1f26/" target="_blank">https://mkimk.github.io/wam1f26/</a>). After confirming the updates, send a Slack message to the student with the next task, informing them that you’ve completed your part. If there are any delays, be sure to communicate with the next person so everything stays on track!</li>
                <li>When we look at the final site, the page will animate between each student’s layout as the users resize the browser window.</li>
              </ul>
              <h5>References & Resources</h5>
              <ul>
                <li><a href="https://en.wikipedia.org/wiki/Exquisite_corpse" target="_blank" rel="noopener noreferrer">Exquisite Corpse</a></li>
                <li><a href="https://en.wikipedia.org/wiki/Round-robin_story" target="_blank" rel="noopener noreferrer">Round Robin Story</a></li>
                <li><a href="https://essenmitsosse.de/pixel/?showcase=true&slide=2" target="_blank" rel="noopener noreferrer">Marcus Blättermann, Responsive Pixel Art</a></li>
                <li><a href="https://www.dropbox.com/s/u8uvw3ojiivhlzz/Each_student_gets_one_media_query%20copy.html?dl=0" target="_blank" rel="noopener noreferrer">A HTML media query sample by Sophia</a></li>
                <li>Potential CSS properties</li>
                <ul>
                  <li class="small">Display: <span class="code">display</span>, <span class="code">z-index</span></li>
                  <li class="small">Position: <span class="code">top</span>, <span class="code">bottom</span>, <span class="code">left</span>, <span class="code">right</span></li>
                  <li class="small">Scale: <span class="code">width</span>, <span class="code">height</span>, <span class="code">max-width</span>, <span class="code">max-height</span></li>
                  <li class="small">Transform: <span class="code">transform</span>, <span class="code">transition</span></li>
                  <li class="small">Animation: <span class="code">@keyframes</span>, <span class="code">animation</span></li>
                  <li class="small">Style: <span class="code">background</span>, <span class="code">border</span>, <span class="code">box-shadow</span>, <span class="code">opacity</span>, <span class="code">filter</span></li>
                  <li class="small">Others: <span class="code">content</span>, <span class="code">mix-blend-mode</span></li>
                </ul>
              </ul>
              <span class="small">Initial assignment designed with <a href="https://sophiaspitulnik.com/index.html" target="_blank" rel="noopener noreferrer">Sophia Spitulnik</a> (RISD GD BFA 19)</span>
            </div>
          </List>
        </Collapse> 
            {/* <ListItem id='e8' className="accordion" button onClick={() => handleClick12("e8")}>
                <ListItemText primary='Exercise 8' className="accordion-heading  maxw-20" /> Patterns
            </ListItem>
            <Collapse in={!e8} timeout="auto"  unmountOnExit>
              <List component="div" disablePadding>
              <div className="accordion-content">
                <div className="img-bleed">
                  <img style={{ maxWidth: '39%',paddingRight: '10px', paddingBottom: '10px' }} src={'https://d7hftxdivxxvm.cloudfront.net/?height=800&quality=50&resize_to=fit&src=https%3A%2F%2Fd32dm0rphc51dk.cloudfront.net%2Fwpn43MMwu72cpFPiJciB4A%2Fmain.jpg&width=684'}></img>
                  <img style={{ maxWidth: '57%', paddingBottom: '10px'}} src={'https://d2w9rnfcy7mm78.cloudfront.net/19105197/original_1041f5eb01eacaa0a421857e811fd630.gif?1669131170?bc=0'}></img>
                  <img style={{ maxWidth: '57%', paddingBottom: '10px' }} src={'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Sierpinski_triangle_evolution.svg/1100px-Sierpinski_triangle_evolution.svg.png'}></img>
                  <h6 style={{  marginBottom: `3rem` }}>
                    (Top left) Samantha Bittman, Untitled, 2023 — a textile exploring mathematical structures.<br/>
                    (Top Right) Gretel, <a href="https://gretelny.com/viceland" target="_blank">Motion design for Viceland</a> — demonstrating computational motion through repetition.<br/>
                    (Bottom Right) The iterations of <a href="https://en.wikipedia.org/wiki/Sierpi%C5%84ski_triangle" target="_blank">the Sierpiński triangle</a> — a fractal in the shape of an equilateral triangle, recursively subdivided into smaller equilateral triangles.<br/>
                  </h6>
                </div>
                <h6 style={{ marginTop: `0rem` }}>Due to 11/25/26</h6>
                <p>Using the in-class demo as a starting point, create three HTML pages, each showing a small visual pattern or composition using at least one loop and one conditional.
                  Your pattern can be based on color, size, spacing, shape, or content.</p>
                <h6 style={{ marginTop: `0rem`}}>Requirements</h6>
                <ul>
                  <li>Use at least one <span class="code">for</span> loop.</li>
                  <li>Use at least one <span class="code">if / else</span> or <span class="code">? :</span> condition.</li>
                  <li>Use CSS styles or <span class="code">style</span> attributes to make the rule visible.</li>
                </ul>
               <h6 style={{ marginTop: `0rem`}}>Examples of directions</h6>
                <ul>
                  <li>Alternate colors or shapes.</li>
                  <li>Gradually change size, opacity, or rotation.</li>
                  <li>Create a grid that follows a logical rule (e.g., every third item different).</li>
                  <li>Create a text-based pattern (“hello”, “hi”, “hello”, “hi” …).</li>
                  <li>Use nested loops</li>
                </ul>
              </div>
              </List>
            </Collapse>  */}
       
      </div >
    </Layout >
  )
}

export default IndexPage




export const query = graphql`
  query {
    allMarkdownRemark(
        sort: { fields: [frontmatter___date], order: ASC } 
        filter: {fileAbsolutePath: {regex: "/t3f19/_project/.*.md$/"}}
        ) {
      totalCount
      edges {
        node {
          html
          id
          frontmatter {
            title
            date
          }
          fields {
            slug
          }
        }
      }
    }
  }
`